import { AnswerStat } from "../interfaces/answerStats.interface";
import useCurrentSlideData from "./useCurrentSlideData";

/**
 * Gets the current AnswerStat.
 *
 * Gets the current slideData and tries to find a correlating answerStats
 *
 * Returns undefined if not found
 *
 * @listens useCurrentSlideData
 * @return {AnswerStat | undefined} AnswerStat | undefined.
 */
const useCurrentAnswerStat = (): AnswerStat | undefined => {
  const currentSlideData = useCurrentSlideData();
  return currentSlideData.answerStat;
};

export default useCurrentAnswerStat;
